import { lazy } from 'react'

const WithdrawalsFunds = lazy(() =>
    import('../../views/common/bancamiga-wallet/withdrawal')
)

const WorkTeam = lazy(() => import('../../views/common/work-team'))


const CommonRoutes = [

    {
        path: '/common/bancamiga-wallet/withdrawal',
        element: <WithdrawalsFunds />,
        action: 'level-1',
        resource: 'common'

        // meta:{

        // }
    },
    {
        element: <WorkTeam />,
        path: '/common/work-team/operational-users',
        action: 'level-1',
        resource: 'common'
    }

]

export default CommonRoutes